import { useMemo } from 'react';
import { Control, DomUtil } from 'leaflet';

const SpinnerControl = Control.extend({
  onAdd: () => {
    const div = DomUtil.create('div');
    const dimensions = '120px';
    div.style.width = dimensions;
    div.style.height = dimensions;
    div.style.display = 'flex';
    div.style.alignItems = 'center';
    div.style.justifyContent = 'center';
    div.innerHTML = `
      <div class="w-100 h-100 p-2 rounded-circle">
        <div class="w-100 h-100 spinner-border">
        </div>
      </div>
    `;
    return div;
  },
  onRemove: () => {},
});

export default function useSpinnerControl(isLoading: boolean) {
  const spinnerLayer = useMemo(() => {
    if (!isLoading) return undefined;

    return new SpinnerControl();
  }, [isLoading]);

  return spinnerLayer;
}
